import { BBMISINAction } from './actions'

export interface State {
  errorMsg: string
  error: boolean
}

export const initialState: State = {
  errorMsg: '',
  error: false
}

export default (state = initialState, action: BBMISINAction): State => {
  switch (action.type) {
    case 'bbmisin.saveBBMISINSuccess':
      return {
        ...state,
        errorMsg: action.payload,
        error: false
      }
    case 'bbmisin.saveBBMISINFailure':
      return {
        ...state,
        errorMsg: action.payload.message ?? '',
        error: true
      }
    case 'bbmisin.clearBBMISINError':
      return {
        ...state,
        errorMsg: '',
        error: false
      }
    default:
      return state
  }
}
